import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import Icon from '@mui/material/Icon';

const DashboardCard = ({ title, count, iconName, color }) => {
  return (
    <Card sx={{
      minWidth: 275,
      margin: 2,
      boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2)',
      transition: "0.3s",
      '&:hover': {
        boxShadow: '0 16px 32px 0 rgba(0,0,0,0.2)',
      },
      borderRadius: '10px', // Rounded corners
      background: 'linear-gradient(to right, #f8f9fa, #e9ecef)', // Subtle background gradient
    }}>
      <CardActionArea>
        <CardContent sx={{ display: 'flex', alignItems: 'center', padding: '20px' }}>
          <Icon sx={{
            fontSize: 60, // Larger icon
            color: color,
            marginRight: 2,
            padding: '10px',
            borderRadius: '50%', // Circular background
            background: `${color}20`, // Light background color for icon
          }}>{iconName}</Icon>
          <div>
            <Typography sx={{ fontSize: 16, fontWeight: 'bold' }} color="text.primary" gutterBottom>
              {title.toUpperCase()}
            </Typography>
            <Typography variant="h4" component="div" sx={{ fontWeight: 'medium' }}>
              {count}
            </Typography>
          </div>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default DashboardCard;
